import GHLForm from "@/components/site/GHLForm";
import { useLang } from "@/lib/i18n";

// Wraps the GoHighLevel intake form with the yellow "Free Estimate" sticker.
// The GHL embed itself contains all field labels and the submit button —
// we render only the iframe and the yellow tag, no duplicate copy.
export default function QuoteForm({ sourcePage = "", minHeight = 760 }) {
  const { t } = useLang();
  return (
    <div data-testid="quote-form-section" className="relative">
      <div className="absolute -top-3 -right-3 z-10 bg-brand-yellow text-slate-900 rounded-full px-4 py-1.5 text-xs font-bold shadow-md uppercase tracking-wider rotate-3">
        {t.common.freeEstimateTag}
      </div>
      <div className="rounded-3xl overflow-hidden shadow-xl ring-1 ring-slate-200">
        <GHLForm minHeight={minHeight} sourcePage={sourcePage} />
      </div>
    </div>
  );
}
